import { render, staticRenderFns } from "./Localisation.vue?vue&type=template&id=7bb69a49&scoped=true&"
import script from "./Localisation.vue?vue&type=script&lang=js&"
export * from "./Localisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb69a49",
  null
  
)

export default component.exports